<div class="editor-container">
    <div class="row">
        <div [ngClass]="hideIncludeDetails ? 'col-xs-12' : 'col-xs-6'" *ngIf="context != 'user-communication' && context != 'notes'">
            <div class="email-html-editor">
                <app-ngx-editor #editorComponent [(ngModel)]="htmlContent" [placeholder]="'Enter text here...'"
                    [spellcheck]="true" [config]="editorConfig"
                    (ngModelChange)="onEditorModelChange($event)">
                </app-ngx-editor>
            </div>
        </div>
        <div *ngIf="context != 'user-communication' && context != 'notes' && !hideIncludeDetails" 
            style="padding-left: 2.5rem;" 
            class="col-xs-6">
            <!-- Include Details Checkboxes -->
            <app-include-details-checkboxes
                [candidateInformationList]="candidateInformationList"
                [selectAll]="selectAllCandidates"
                [title]="'INCLUDE THE FOLLOWING IN EMAIL BODY:'"
                [checkboxPrefix]="'candidate'"
                [selectedProp]="'selected'"
                [isNotesContext]="false"
                (selectAllToggle)="selectAllCandidates = $event; onSelectAllCandidates()"
                (candidateToggle)="onCandidateCheckboxChange($event)">
            </app-include-details-checkboxes>
        </div>
        <div class="col-xs-12 mt-4" *ngIf="context == 'user-communication' || context == 'notes'">
            <!-- Include Details Checkboxes -->
            <div class="col-xs-12 px-0">
                <app-include-details-checkboxes
                    [candidateInformationList]="candidateInformationList"
                    [selectAll]="selectAllCandidatesNC"
                    [title]="'INCLUDE THE FOLLOWING IN ' + (context == 'notes' ? 'NOTES' : 'COMMUNICATION') + ':'"
                    [checkboxPrefix]="'candidateNC'"
                    [selectedProp]="'selectedForNote'"
                    [isNotesContext]="true"
                    (selectAllToggle)="selectAllCandidatesNC = $event; onSelectAllCandidatesNC()"
                    (candidateToggle)="onCandidateCheckboxChangeNC($event)">
                </app-include-details-checkboxes>
            </div>
            <label for="notes" class="control-label mb-3" *ngIf="context == 'user-communication'">
                Message<em>*</em> :
            </label>
             <label for="notes" class="control-label mb-3" *ngIf="context == 'notes'">
                Notes<em>*</em> :
            </label>
            <div class="email-html-editor">
                <textarea name="notes" class="form-control" rows="5" placeholder="Enter your note.." [value]="displayedNote"
                    (input)="onNoteChange($event)" required>
                </textarea>
            </div>
        </div>
    </div>

    <!-- <div class="preview">
        <h4>Preview:</h4>
        <div [innerHTML]="htmlContent"></div>
        <div>{{htmlContent}}</div>
    </div> -->
</div>